export default __webpack_public_path__ + "static/media/Vivek.d28fd7ab.png";